import * as React from 'react';
import Svg, {ClipPath, Defs, G, Path, Rect} from 'react-native-svg';
import {backgroundColor} from 'src/components/img/svg/rewards/PayEarnPoints';
interface IProps {
  color?: string;
  width?: number;
  height?: number;
}
const PayEarnedStatus = ({
  width = 51,
  height = 50,
  color = '#006DFF',
}: IProps) => (
  <Svg width={width} height={height} viewBox="0 0 50 50" fill="none">
    <Rect
      width={width}
      height={height}
      rx={8}
      fill={backgroundColor(color).color}
      fillOpacity={backgroundColor(color).opacity}
    />
    <G clipPath="url(#clip0_3340_4950)">
      <Path
        d="M20.563 11.313A1.31 1.31 0 0019.25 10a1.31 1.31 0 00-1.313 1.313V13.5H15.75c-1.93 0-3.5 1.57-3.5 3.5v17.5c0 1.93 1.57 3.5 3.5 3.5h17.5c1.93 0 3.5-1.57 3.5-3.5V17c0-1.93-1.57-3.5-3.5-3.5h-2.188v-2.188A1.31 1.31 0 0029.75 10a1.31 1.31 0 00-1.313 1.313V13.5h-7.875v-2.188zM14.875 20.5h19.25v14a.878.878 0 01-.875.875h-17.5a.878.878 0 01-.875-.875v-14z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_3340_4950">
        <Path fill="#fff" transform="translate(12.25 10)" d="M0 0H24.5V28H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default PayEarnedStatus;
